import { formatListData } from 'commons-ui';
import { IPermissionInfo } from 'models/settingsV2.model';
import { useCallback } from 'react';

const useService = (userPermissionsDetails: IPermissionInfo[]) => {
	const permissionIdsLength: number = userPermissionsDetails ? userPermissionsDetails.length : 0;
	const getUserPermissionsData = useCallback(async () => {
		const listData: IPermissionInfo[] = formatListData(userPermissionsDetails);
		return { rowCount: permissionIdsLength, data: listData };
	}, []);

	return {
		getUserPermissionsData
	};
};

export default useService;
